 <template>
  <div class="bg-purple">
    <el-card class="box-card">
      <el-tabs  @tab-click="handleClick" v-loading='loadingAssignedApplications' v-model="activeName" type="border-card" stretch>
        <el-tab-pane name="fromProponent">
          <span slot="label">Από εισηγητή <span class="todo-badge"> {{fromProponentNewLength}}</span> <span class="done-badge"> {{fromProponentFinalLength}}</span> </span>
          <el-table ref="singleTable" stripe border highlight-current-row style="width: 100%" :data="loadAssignedAppsProponent" @row-click="loadApp">
            <el-table-column type="index" :index="indexMethod" width="30"></el-table-column>
            <el-table-column prop="surname" label="Επώνυμο"></el-table-column>
            <el-table-column prop="name" label="Όνομα"></el-table-column>
            <el-table-column prop="academicAreaTitle" label="Ακαδημαϊκή περιοχή"></el-table-column>
            <el-table-column label="Ημ/νια Ολοκλήρωσης Προελέγχου" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.dateCompleted.substring(0,10)}}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="Κατάσταση" align="center" width="100">
              <template slot-scope="scope">
                <span class="done-btn" v-if="scope.row.finalizedByUser"> <i class="el-icon-check"></i></span>
                <span class="todo-btn" v-if="!scope.row.finalizedByUser"> <i class="el-icon-edit"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="fromPresident">
          <span slot="label">Από Πρόεδρο <span class="todo-badge"> {{fromPresidentNewLength}}</span>
          <span class="done-badge"> {{fromPresidentFinalLength}}</span> </span>
          <el-table ref="singleTable" stripe border highlight-current-row style="width: 100%" :data="loadAssignedAppsPresident" @row-click="loadApp">
            <el-table-column type="index" :index="indexMethod" width="30"></el-table-column>
            <el-table-column prop="surname" label="Επώνυμο"></el-table-column>
            <el-table-column prop="name" label="Όνομα"></el-table-column>
            <el-table-column prop="academicAreaTitle" label="Ακαδημαϊκή περιοχή"></el-table-column>
            <el-table-column label="Ημ/νια Ολοκλήρωσης Προελέγχου" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.updatedAt.substring(0,10)}}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="Κατάσταση" align="center" width="100">
              <template slot-scope="scope">
                <span class="done-btn" v-if="scope.row.finalizedByUser"> <i class="el-icon-check"></i></span>
                <span class="todo-btn" v-if="!scope.row.finalizedByUser"> <i class="el-icon-edit"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="fromConsultant">
          <span slot="label">Από Ακαδ. Σύμβουλο <span class="todo-badge"> {{fromConsultantNewLength}}</span> <span class="done-badge"> {{fromConsultantFinalLength}}</span> </span>
          <el-table ref="singleTable" stripe border highlight-current-row style="width: 100%" :data="loadAssignedAppsConsultant" @row-click="loadApp">
            <el-table-column type="index" :index="indexMethod" width="30"></el-table-column>
            <el-table-column prop="surname" label="Επώνυμο"></el-table-column>
            <el-table-column prop="name" label="Όνομα"></el-table-column>
            <el-table-column prop="academicAreaTitle" label="Ακαδημαϊκή περιοχή"></el-table-column>
            <el-table-column label="Ημ/νια Ολοκλήρωσης Προελέγχου" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.updatedAt.substring(0,10)}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="Ενέργειες" width="200">
              <template slot-scope="scope">
                <el-button @click="dialogView = true, assignedApp = scope.row, toggleApplication(assignedApp)" type="text" size="small">Προβολή</el-button>
              </template>
            </el-table-column> -->
            <el-table-column fixed="right" label="Κατάσταση" align="center" width="100">
              <template slot-scope="scope">
                <span class="done-btn" v-if="scope.row.finalizedByUser"> <i class="el-icon-check"></i></span>
                <span class="todo-btn" v-if="!scope.row.finalizedByUser"> <i class="el-icon-edit"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
         <el-tab-pane name="fromVice">
          <span slot="label">Από Αντιπρόεδρο <span class="todo-badge"> {{fromViceNewLength}}</span>
          <span class="done-badge"> {{fromViceFinalLength}}</span> </span>
          <el-table ref="singleTable" stripe border highlight-current-row style="width: 100%" :data="loadAssignedAppsVice" @row-click="loadApp">
            <el-table-column type="index" :index="indexMethod" width="30"></el-table-column>
            <el-table-column prop="surname" label="Επώνυμο"></el-table-column>
            <el-table-column prop="name" label="Όνομα"></el-table-column>
            <el-table-column prop="academicAreaTitle" label="Ακαδημαϊκή περιοχή" width="170"></el-table-column>
            <el-table-column prop="applicationType" label="Είδος αίτησης" width="130"></el-table-column>
            <el-table-column label="Ανάθεση" width="95" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.updatedAt.substring(0,10)}}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="Κατάσταση" align="center" width="100">
              <template slot-scope="scope">
                <span class="done-btn" v-if="scope.row.finalizedByUser"> <i class="el-icon-check"></i></span>
                <span class="todo-btn" v-if="!scope.row.finalizedByUser"> <i class="el-icon-edit"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog :visible.sync="dialogViewComp" :close-on-click-modal='false' v-loading="loadingWorkingApplication"
    :close-on-press-escape='false' :show-close='true' :center='true' style="background-color: transparent;">
      <el-card class="box-card bg-purple">
        <div slot="header">
          <UserAppInfo></UserAppInfo>
        </div>
        <div class="text item">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <template>
              <executive-board-member-judgement v-if="showWorkingApplication" @closeDialogEvent='closeDialogEvent'></executive-board-member-judgement>
            </template>
          </el-tabs>
        </div>
       </el-card>
    </el-dialog>
  </div>
</template>

<script>
import ExecutiveBoardMemberJudgement from '../roleSpecific/ExecutiveBoardMemberJudgement'
import { mapState } from 'vuex'
import UserAppInfo from '../common/UserAppInfo'

export default {
  components: {
    ExecutiveBoardMemberJudgement,
    UserAppInfo
  },
  data () {
    return {
      dialogView: false,
      activeName: 'fromProponent'
    }
  },
  methods: {
    loadApp (val) {
      this.$store.dispatch('LOAD_WORKING_APPLICATION', val.id)
      this.dialogView = true
    },
    indexMethod (index) {
      return index + 1
    },
    handleClick (ev) {
    },
    toggleApplication (assignedApp) {
      this.$store.dispatch('LOAD_WORKING_APPLICATION', assignedApp.id)
    },
    closeDialogEvent () {
      this.dialogView = false
    }
  },
  computed: {
    fromProponentFinalLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Proponent' && app.finalizedByUser === true
      }).length
    },
    fromConsultantFinalLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Consultant' && app.finalizedByUser === true
      }).length
    },
    fromPresidentFinalLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_President' && app.finalizedByUser === true
      }).length
    },
    fromViceFinalLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Vice' && app.finalizedByUser === true
      }).length
    },
    fromProponentNewLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Proponent' && app.finalizedByUser === false
      }).length
    },
    fromPresidentNewLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_President' && app.finalizedByUser === false
      }).length
    },
    fromViceNewLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Vice' && app.finalizedByUser === false
      }).length
    },
    fromConsultantNewLength () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Consultant' && app.finalizedByUser === false
      }).length
    },
    dialogViewComp: {
      get: function () {
        return this.dialogView // && this.showWorkingApplication
      },
      set: function (value) {
        this.dialogView = value
      }
    },
    loadAssignedAppsProponent () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Proponent'
      })
    },
    loadAssignedAppsPresident () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_President'
      })
    },
    loadAssignedAppsVice () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Vice'
      })
    },
    loadAssignedAppsConsultant () {
      return this.assignedApplications.filter(app => {
        return app.applicationStatus === 'boardW_Consultant'
      })
    },
    ...mapState([
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'loadingAssignedApplications',
      'loadingWorkingApplication'
    ])
  },
  watch: {
  }
}
</script>

<style lang="scss">

.bg-purple {
  background: #d3dce6;
}
.el-table td {
    background-color: #fff;
    line-height: 40px;
    padding: 0px;
}
.el-table .cell {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: normal;
    word-break: break-all;
    min-height: 50px;
    max-height: 50px;
    line-height: 50px;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.todo-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-badge {
    background-color:#67c23a;
    border-radius: 5px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
}
.todo-badge {
    background-color: orange;
    border-radius: 5px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
}
.el-dialog {
  width: 90%;
}
.el-card__body {
  padding: 2px;
}
.el-input--small .el-input__inner {
  width: 200px
}
// .el-card {
//   margin: 5px;
// }
// .list-group-item {
//   cursor: move;
//   background-color: #7fa3bb;
//   &:hover {
//     background-color: #4d7590;
//   }
// }
// .list-group-item {
//   cursor: move;
//   background-color: #7fa3bb;
//   &:hover {
//     background-color: #4d7590;
//   }
//   position: relative;
//   display: block;
//   margin-bottom: 0px;
//   border: 1px solid rgba(0,0,0,.125);
//   border-radius: 4px
// }
// .list-group {
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: normal;
//   -ms-flex-direction: column;
//   flex-direction: column;
//   padding-left: 0;
//   margin-bottom: 0;
// }
// ul, menu, dir {
//   display: block;
//   list-style-type: disc;
//   -webkit-margin-after: 1em;
//   -webkit-margin-start: 0px;
//   -webkit-margin-end: 0px;
//   // -webkit-padding-start: 40px;
// }
</style>



// WEBPACK FOOTER //
// src/components/common/ExecutiveBoardMemberApplicationsLane.vue